export default __webpack_public_path__ + "static/media/sketch-corporate-tn.0eee6e90.png";